import { createTheme, darken, lighten } from '@mui/material/styles';
import theme from 'src/themes/baseTheme';

const homebarTheme = createTheme(theme, {
  palette: {
    primary: {
      light: lighten('#5E3BEE', 0.45),
      main: '#5E3BEE',
      dark: darken('#5E3BEE', 0.45),
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: lighten('#27D9C5', 0.45),
      main: '#27D9C5',
      dark: darken('#27D9C5', 0.45),
      contrastText: '#FFFFFF',
    },
    error: {
      light: '#EF5350',
      main: '#E53935',
      dark: '#B71C1C',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#759AFF',
      contrastText: '#fff',
      light: '#8799CC',
      dark: '#1C2233',
    },
    success: {
      light: lighten('#27d983', 0.2),
      main: '#27d983',
      dark: darken('#27d983', 0.2),
      contrastText: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 5,
  },
});

export default homebarTheme;
